import { render } from "./dashboard.vue?vue&type=template&id=dbc0bb9c&scoped=true"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"

import "./dashboard.vue?vue&type=style&index=0&id=dbc0bb9c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbc0bb9c"]])

export default __exports__